class MBSubscriptionForm extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback () {
		this.initElements();
		this.initEvents();
	}

	initElements() {
		this.form = this.querySelector("[data-collect-form]");
		this.submitButton = this.querySelector("[data-collect-button]");
		this.collectMessages = this.querySelector("[data-collect-form-status-message]");
		this.formField = this.querySelector("[data-collect-form-field]");
	}

	initEvents() {
		if (this.form) {
			this.form.addEventListener("submit", (event) => {
				event.preventDefault();

				this.sendData();
			});
		}
	}
	sendData() {
		const customerEmail = this.formField.value;

		if(!customerEmail) {
			return null;
		}

		mindbox("async", {
			operation: "customerRegistrationEu",
			data: {
				customer: {
					email: `${customerEmail}`,
					subscriptions: [
						{
							brand: "UnidragonEu",
							pointOfContact: "Email"
						}
					]
				}
			},
			onSuccess: this.onSuccess()
		});
	}

	onSuccess() {
		if (this.collectMessages) {
			this.formField.classList.add("hidden");
			this.collectMessages.classList.remove("hidden");
			this.collectMessages.classList.add("success");

			this.collectMessages.innerHTML = "Form submit successfully"
		}

		if (this.submitButton){
			this.submitButton.disabled = true;
		}
	}
}

if (!customElements.get('mb-subscription-form')) {
	customElements.define('mb-subscription-form', MBSubscriptionForm);
}
